import { render } from "./MovieSection.vue?vue&type=template&id=0ac46adf&scoped=true"
import script from "./MovieSection.vue?vue&type=script&lang=js"
export * from "./MovieSection.vue?vue&type=script&lang=js"

import "./MovieSection.vue?vue&type=style&index=0&id=0ac46adf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac46adf"]])

export default __exports__